import { LOCALSTORAGE_KEYS } from '@features/General'
import cloneDeep from 'lodash/cloneDeep'
import dayjs from 'dayjs'

export const getAuthToken = () => {
    const chatInfo = localStorage.getItem(LOCALSTORAGE_KEYS.ROCKET_CHAT_INFO)
    if (chatInfo) {
        const { authToken, userId } = JSON.parse(chatInfo)
        return {
            token: authToken,
            userId: userId
        }
    } else {
        return {
            token: null,
            userId: null
        }
    }
}

const uniqueIds = {
    login: '0',
    fetchHistory: '1',
    sendMessage: '5',
    subscribeRoom: '3',
    subscribeStatus: '6',
    setOnlineStatus: '7',
    typingStatus: '8',
    archiveRoom: '97',
    changeMessage: '42'
}

export const connectMessage = ws => {
    const openingMessage = {
        msg: 'connect',
        version: '1',
        support: ['1', 'pre2', 'pre1']
    }
    ws.current.send(JSON.stringify(openingMessage))
}

export const pongMessage = ws => {
    ws.current.send(JSON.stringify({ msg: 'pong' }))
}

export const login = ws => {
    const { token } = getAuthToken()
    if (token) {
        const msg = {
            msg: 'method',
            method: 'login',
            id: '42',
            params: [{ resume: token }]
        }
        ws.current.send(JSON.stringify(msg))
    }
}

export const sendMessage = (ws, msg, rid) => {
    const msgConfig = {
        msg: 'method',
        method: 'sendMessage',
        id: uniqueIds.sendMessage,
        params: [
            {
                rid,
                msg
            }
        ]
    }
    ws.current.send(JSON.stringify(msgConfig))
}

export const fetchHistory = (ws, groupId) => {
    const msg = {
        msg: 'method',
        method: 'loadHistory',
        id: uniqueIds.fetchHistory,
        params: [groupId, null, 50, null]
    }
    ws.current.send(JSON.stringify(msg))
}

export const subscribeToRoom = (ws, groupId) => {
    const msg = {
        msg: 'sub',
        id: uniqueIds.subscribeRoom,
        name: 'stream-room-messages',
        params: [groupId, false]
    }
    ws.current.send(JSON.stringify(msg))
}

export const unsubscribeToRoom = ws => {
    const msg = {
        msg: 'unsub',
        id: uniqueIds.subscribeRoom
    }
    ws.current.send(JSON.stringify(msg))
}

export const subscribeUserStatus = ws => {
    const msg = {
        msg: 'sub',
        id: uniqueIds.subscribeStatus,
        name: 'stream-notify-logged',
        params: ['user-status', false]
    }

    ws.current.send(JSON.stringify(msg))
}

export const isUserStatus = ({ msg, collection, id }) => {
    return msg === 'changed' && collection === 'stream-notify-logged' && id === uniqueIds.subscribeStatus
}

export const setOnlineStatus = ws => {
    const msg = {
        msg: 'method',
        method: 'UserPresence:setDefaultStatus',
        id: uniqueIds.setOnlineStatus,
        params: ['online']
    }
    ws.current.send(JSON.stringify(msg))
}

export const subscriptionUser = (ws, event) => {
    const { userId } = getAuthToken()
    const config = {
        msg: 'sub',
        id: '42',
        name: 'stream-notify-user',
        params: [`${userId}/${event}`, false]
    }
    // console.log('config', config)
    ws.current.send(JSON.stringify(config))
}

export const typingIndicatorSub = (ws, groupId, username, typing) => {
    const msg = {
        msg: 'method',
        id: '42',
        method: 'stream-notify-room',
        params: [`${groupId}/typing`, username, typing]
    }
    ws.current.send(JSON.stringify(msg))
}

export const getSubscription = ws => {
    const getSubscriptionConfig = {
        msg: 'method',
        method: 'subscriptions/get',
        id: '42',
        params: [{ $date: 1480377601 }]
    }
    ws.current.send(JSON.stringify(getSubscriptionConfig))
}

export const typingIndicator = (ws, groupId, username, typing) => {
    const msg = {
        msg: 'method',
        method: 'stream-notify-room',
        id: '8',
        params: [`${groupId}/typing`, username, typing]
    }
    ws.current.send(JSON.stringify(msg))
}

export const scrollToLast = messageContainer => {
    messageContainer.current &&
        messageContainer.current.scrollTo({
            top: messageContainer.current.scrollHeight,
            behavior: 'smooth'
        })
}

export const scrollToMessage = (messageContainer, anchorMessage, removeAnchorMessage) => {
    // messageContainer.scrollTop = height;
    const messageDom = document.getElementById(anchorMessage)
    messageContainer.current &&
        messageContainer.current.scrollTo({
            top: messageDom.offsetTop - 80,
            behavior: 'smooth'
        })
    removeAnchorMessage()
}

export const createDirectMessage = (ws, userId) => {
    const createMessageConfig = {
        msg: 'method',
        method: 'createDirectMessage',
        id: uniqueIds.changeMessage,
        params: [userId]
    }
    ws.current.send(JSON.stringify(createMessageConfig))
}

export const deleteDirectMessage = (ws, message_id) => {
    const deleteMessageConfig = {
        msg: 'method',
        method: 'deleteMessage',
        id: uniqueIds.changeMessage,
        params: [{ _id: message_id }]
    }
    ws.current.send(JSON.stringify(deleteMessageConfig))
}

export const readMessages = (ws, roomId) => {
    const readMessagesConfig = {
        msg: 'method',
        method: 'readMessages',
        id: '42',
        params: [roomId]
    }
    ws.current.send(JSON.stringify(readMessagesConfig))
}

export const getPublicSettings = ws => {
    const settingConfig = {
        msg: 'method',
        method: 'public-settings/get',
        id: '42'
    }
    ws.current.send(JSON.stringify(settingConfig))
}

export const groupMessagesByDate = messages => {
    const groups = cloneDeep(messages)
        .sort((a, b) => a.ts.$date - b.ts.$date)
        .reduce((groups, message) => {
            const { msgDate, msgResult } = getMsgInfo(message)
            if (!groups[msgDate]) {
                groups[msgDate] = []
            }
            groups[msgDate].push(msgResult)
            return groups
        }, {})

    const groupArrays = Object.keys(groups).map(date => {
        const today = dayjs()
        const yesterday = dayjs().add(-1, 'days')
        const mDate = dayjs(date)
        return {
            date,
            dateTitle: mDate.isSame(today, 'day')
                ? 'Today'
                : mDate.isSame(yesterday, 'day')
                ? 'Yesterday'
                : mDate.format('DD MMMM YYYY'),
            messages: groups[date]
        }
    })
    return groupArrays.sort((a, b) => new Date(a.date).valueOf() - new Date(b.date).valueOf())
}

export const getMsgInfo = msg => {
    const msgDateTime = dayjs.unix(msg.ts.$date / 1000)
    const msgDate = msgDateTime.format().toString().substring(0, 10)

    return {
        msgDate,
        msgResult: { ...msg, time: msgDateTime.format('hh:mm a') }
    }
}

export const messageIsMine = message => {
    const authToken = getAuthToken()
    return authToken.userId === message.u._id
}
